import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import {
  fetchTopicsForPinnedKnowledge,
  updateTopicPinnedKnowledgeFulfilled,
  updateTopicPinnedKnowledgeRejected,
} from "domains/pinAddReject/actions";
import type { UpdateTopicPinnedKnowledge } from "domains/pinAddReject/actionTypes";

export function* updateTopicPinnedKnowledgeSaga(action: UpdateTopicPinnedKnowledge) {
  const { topicId, knowledgeId, isPinned } = action.meta;

  try {
    yield apiFetch(`topic/${topicId}/knowledge/pin`, {
      method: "PATCH",
      body: {
        add: isPinned ? [] : [knowledgeId],
        remove: isPinned ? [knowledgeId] : [],
      },
    });

    yield put(updateTopicPinnedKnowledgeFulfilled({ ...action.meta, isPinned: !isPinned }));
    yield put(fetchTopicsForPinnedKnowledge({ knowledgeId }));
  } catch (error) {
    logger.error("[updateTopicPinnedKnowledgeSaga] Error occurred while updating pinned knowledge", error);
    yield put(updateTopicPinnedKnowledgeRejected({ ...action.meta, logoutOnAuthError: true }));
  }
}
